import { Outlet } from 'react-router-dom'

const Coin = () => <Outlet />

export default Coin
